import { cn } from '@/shared/ui/primitives'
import { STATUS_LABEL, type ProformaStatus } from './types'

/**
 * Colour by what the status asks of someone, not by the status itself:
 * amber waits on an approver, red needs the drafter, green is cleared,
 * blue has left for the ERP, purple is billed. Grey means nothing is moving.
 */
const TONE: Record<ProformaStatus, string> = {
  DRAFT: 'bg-gray-200 text-gray-600',
  PENDING_APPROVAL: 'bg-warning-light text-warning-ink',
  RETURNED: 'bg-danger-light text-danger',
  REJECTED: 'bg-danger-light text-danger',
  APPROVED: 'bg-success-light text-success-ink',
  CANCELLED: 'bg-gray-200 text-gray-500',
  POSTED: 'bg-primary-light text-primary-active',
  PARTIALLY_POSTED: 'bg-primary-light text-primary-active',
  POST_FAILED: 'bg-danger-light text-danger',
  INVOICED: 'bg-info-light text-info',
  CLOSED: 'bg-info-light text-info',
}

/** Status as a pill with a dot, so it reads at a glance down a list. The one badge for proforma status. */
export function StatusPill({ status, className }: { status: ProformaStatus; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex w-fit items-center gap-1.5 rounded-full py-0.5 pr-2.5 pl-2 text-xs font-semibold whitespace-nowrap',
        TONE[status],
        className,
      )}
    >
      <span aria-hidden="true" className="size-1.5 rounded-full bg-current" />
      {STATUS_LABEL[status]}
    </span>
  )
}
